



























































































import { Meta } from "@/store/meta"
import { Component } from "vue-property-decorator"
import { Server } from '@/store/server'
import { getModule } from "vuex-module-decorators"
import { Dictionary } from "@/mixins/dictionary"
import { DateTime } from "@/mixins/datetime"
import { mixins } from "vue-class-component"
@Component({
})
export default class Payments extends mixins(Dictionary, DateTime) {

  // eslint-disable-next-line
  paymentsViewArray = [] as any
  // eslint-disable-next-line
  paymentsView: { [key: string]: any } = {
    "paid": "",
    "dueData": "",
    "paymentMethod": "",
    "amount": "",
    "id": ""
  }

  isLoading = false

  columnNum= 50
  total = 0 as number
  pageMax = 0 as number
  pageCurrent = 1 as number
  pageDone: boolean[] = []
  pageButtonNum = 5 as number
  pageButtonView: boolean[] = []
  pageButtonFirstPoints = false
  pageButtonLastPoints = false
  isView = false

  //paginate
  rangeBefore= 2
  rangeAfter= 2
  order= 'is-right'
  size= 'is-medium'
  isSimple= false
  prevIcon= 'chevron-left'
  nextIcon= 'chevron-right'

  async mounted() {
    this.isLoading = true
    this.isView = await this.server.getPayments()
    this.isLoading = false
    if(!this.isView)return
    this.pageDone[1] = true
    this.columnNum = this.server.PaymentsDataOption.limit
    this.total = this.server.PaymentsDataOption.total
    this.pageMax = Math.ceil(this.total / this.columnNum)
    this.updatePaymentsEntries()
  }
  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }

  get paymentEntries(){
    this.jumpTable(this.pageCurrent)
    return this.paymentsViewArray
  }

  updatePaymentsEntries() {
    let paymentsData = []
    paymentsData = this.server.PaymentsData
    const startIndex = this.columnNum*(this.pageCurrent-1)
    const endIndex = startIndex + this.columnNum
    if(0 < paymentsData.length){
      this.paymentsViewArray.splice(0)
      for(let i = startIndex; i<endIndex;i++){
        if(this.total <=i)break
        this.paymentsView.paid = paymentsData[i].paid
        this.paymentsView.dueDate = paymentsData[i].due_date
        this.paymentsView.paymentMethod = paymentsData[i].payment_method
        this.paymentsView.plan = paymentsData[i].plan
        this.paymentsView.amount = paymentsData[i].amount
        this.paymentsView.id = paymentsData[i].id
        this.paymentsViewArray.push(Object.assign({}, this.paymentsView))
      }
    }
  }

  detailLink(id: string){
    this.$router.push({ path: '/payments/' + id});
  }

  async jumpTable(id: number){
    this.pageCurrent = id
    if(!this.pageDone[this.pageCurrent]){
      this.pageDone[this.pageCurrent] = true
      const offset =  this.columnNum * (this.pageCurrent - 1)
      await this.server.getPayments(offset)
    }
    this.updatePaymentsEntries()
  }

}
